import valid from 'card-validator';

import { MADA_CARD_BINS, OMAN_NET_CARD_BINS } from '../constants/index';

export const registerCustomCards = ({
  card,
  noCardLogo,
}: {
  card?: string;
  noCardLogo?: boolean;
}) => {
  valid.creditCardType.addCard({
    niceType: 'Premium',
    type: 'premiumcard',
    patterns: [101],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVV',
      size: 3,
    },
    matchStrength: 3,
  });
  if (!noCardLogo) {
    valid.creditCardType.addCard({
      niceType: 'Meeza',
      type: 'meezacard',
      patterns: [507803],
      gaps: [4, 8, 12],
      lengths: [16],
      code: {
        name: 'CVV',
        size: 3,
      },
      matchStrength: 4,
    });
    valid.creditCardType.addCard({
      niceType: 'Mada',
      type: 'madacard',
      patterns: MADA_CARD_BINS,
      gaps: [4, 8, 12],
      lengths: [16],
      code: {
        name: 'CVV',
        size: 3,
      },
      matchStrength: 4,
    });
    valid.creditCardType.addCard({
      niceType: 'OmanNet',
      type: 'omannet',
      patterns: OMAN_NET_CARD_BINS,
      gaps: [4, 8, 12],
      lengths: [16],
      code: {
        name: 'CVV',
        size: 3,
      },
      matchStrength: 4,
    });
    if (card) {
      if (card.startsWith('9999')) {
        valid.creditCardType.changeOrder('madacard', 0);
      } else if (card.startsWith('101')) {
        valid.creditCardType.changeOrder('premiumcard', 0);
      } else if (card.startsWith('439357')) {
        valid.creditCardType.changeOrder('omannet', 0);
      } else {
        valid.creditCardType.changeOrder('meezacard', 0);
      }
    }
  }
};
